import useAxios from "@hooks/use-axios";
import { toastify } from "@helpers/toast";
import { UPLOAD_ENDPOINT } from "@constants/endpoints";
import { CONTRACT_UPLOAD_TYPE } from "../misc/constants";

/**
 * Puts the picked file in storage and hands back what the save endpoint
 * needs. Uploading is deliberately not the same act as creating the contract:
 * the object lands in the bucket, nothing is written to the database, and
 * cancelling the confirmation step leaves the contract on record untouched.
 */
const useContractUpload = () => {
    const { axiosInstance, loading: uploading } = useAxios({ base: "base", showAlert: false });

    const uploadFile = async (file) => {
        if (!file) return null;

        try {
            const formData = new FormData();
            formData.append("file", file);

            const res = await axiosInstance.post(UPLOAD_ENDPOINT, formData, {
                params: { type: CONTRACT_UPLOAD_TYPE }
            });

            const uploaded = (res.data || [])[0];
            if (!uploaded?.url) {
                toastify({ title: "Upload failed. Please try again.", type: "error" });
                return null;
            }

            return {
                url         : uploaded.url,
                // The uploader answers with `path`/`originalName`; `name` is
                // what `contract_meta.name` is validated against, so fall all
                // the way back to the picked file rather than sending null.
                name        : uploaded.name || uploaded.path || uploaded.originalName || file.name,
                originalName: uploaded.originalName || file.name,
                size        : uploaded.size ?? file.size
            };
        } catch {
            toastify({ title: "Upload failed. Please try again.", type: "error" });
            return null;
        }
    };

    return { uploading, uploadFile };
};

export default useContractUpload;
